import { useCallback, useEffect, useMemo, useState } from "react";

export default function useI18nFieldState<T>(
  i18nFieldName: string,
  selectedLanguage: string,
  value: T,
  onChange: (newValue: T) => void
) {
  const [displayedValue, setDisplayedValue] = useState<string>("");

  const targetedFieldName = useMemo(() => {
    return `${i18nFieldName}_${selectedLanguage}`;
  }, [i18nFieldName, selectedLanguage]);

  const triggerSetValue = useCallback(
    (newValue: string) => {
      const valueCopy = { ...value };
      valueCopy[targetedFieldName] = newValue;
      onChange({ ...valueCopy });
    },
    [onChange, targetedFieldName, value]
  );

  useEffect(() => {
    setDisplayedValue(value[targetedFieldName] ?? "");
  }, [selectedLanguage, targetedFieldName, value]);

  return {
    displayedValue,
    triggerSetValue,
    setDisplayedValue,
  };
}
